import { Button } from '@design-system/button';
import { Container } from '@design-system/container';
import { Typography } from '@design-system/typography';
import classnames from 'classnames';
import React, { FC } from 'react';

import { SORT_BY } from '~/hooks/useFilter';

import { sortOptions } from './constants';
import { ItemListingDefaultSortByProps } from './models';

const ItemListingDefaultSortBy: FC<ItemListingDefaultSortByProps> = ({
  handleSortChange,
  itemsAmount,
  isSortingOpen,
  toggleSortingOpen,
  sort,
  itemsName,
  sortBy: { mainLabel, nameAscLabel, nameDescLabel, recentLabel, defaultLabel },
}) => (
  <Container maxWidth="max-grid" className="sort-by">
    <div className="sort-by__items-counter">
      <Typography
        content={`${itemsName}`}
        tag="h3"
        variant="headline"
        size="xs"
        align="start"
      />
      <Typography
        content={`(${itemsAmount})`}
        tag="span"
        variant="headline"
        size="xs"
        align="start"
      />
    </div>
    <div className="sort-by__selection-wrapper">
      <div className="sort-by__selection">
        <Button
          variant="subtle"
          size="large"
          onClick={() => toggleSortingOpen()}
          className={classnames(
            'sort-by__selection-btn sort-by__selection-btn--underline',
            {
              'sort-by__selection-btn--open': isSortingOpen,
            }
          )}
          iconSuffix={{
            props: {
              icon: 'arrowDown',
            },
          }}
        >
          {mainLabel}
        </Button>
        {isSortingOpen ? (
          <div className="sort-by__options">
            {sortOptions.map((sortOption) => (
              <Button
                key={sortOption}
                variant="subtle"
                size="large"
                onClick={() => handleSortChange(sortOption)}
                className={classnames('sort-by__option', {
                  'sort-by__option--active': sort === sortOption,
                })}
              >
                {
                  {
                    [SORT_BY.NAME_ASC]: nameAscLabel,
                    [SORT_BY.NAME_DESC]: nameDescLabel,
                    [SORT_BY.RECENT]: recentLabel,
                    [SORT_BY.DEFAULT]: defaultLabel,
                  }[sortOption]
                }
              </Button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  </Container>
);
export default ItemListingDefaultSortBy;
